var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-desc-root-container"},[_c('img',{staticClass:"base-desc-edit",attrs:{"src":_vm.icons.edit},on:{"click":_vm.edit}}),_c('span',{staticClass:"base-desc-title"},[_vm._v("项目描述")]),_c('p',[_vm._v(_vm._s(_vm.dataSource.more))]),_c('base-desc-drawer',{ref:"baseDescDrawer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }